
<script>
import DishCard from './dishCard.vue'

export default {
    components: { DishCard },
    props: {
        category: {
            type: Object,
        },
        categoryIndex: {
            type: Number,
        }
    },
    data() {
        return {
            isRotated: false
        };
    },
    mounted() {
    },
    methods: {
        toggleCollapse() {
            this.isRotated = !this.isRotated;
        },
        openEdit(dish) {
            this.$emit('edit-dish', dish)
        },
        openDeleteDishModal(dish) {
            this.$emit('delete-dish', dish)
        },
        openIsAsctiveDishModal(dish) {
            this.$emit('is-active-dish', dish)
        },
        handleCategoryName(name){
            if(name === 'OTHERS') return 'OTROS'
            return name
        },
        formatCategoryName(name) {
            return name.split(' ').map(word => {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            }).join(' ');
        }
    },
}
</script>

<template class="my-dishes">
    <div v-if="category.dishes.length > 0">
        <div class="my-dishes-category" v-b-toggle="`collapse-dishes-${categoryIndex}`" size="sm" @click="toggleCollapse()">
            {{ handleCategoryName(this.formatCategoryName(category.name)) }} <span>({{ category.dishes.length }})</span>
            <img :class="isRotated ? 'rotated' : ''" src="@/assets/images/accordeon-up.svg" alt="">
        </div>
        <b-collapse :id="`collapse-dishes-${categoryIndex}`" class="mt-2" visible>
            <div class="my-dishes-cards">
                <div v-for="(dish, index) in category.dishes" :key="index">
                    <DishCard :dish="dish" :actions="true" @edit-dish="openEdit(dish)"
                        @delete-dish="openDeleteDishModal(dish)" @is-active-dish="openIsAsctiveDishModal(dish)" />
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/views/my-dishes/dishCardContainer';
</style>